module.exports = __webpack_public_path__ + "media/images/p-projectOverviews/gift-db338237e64bbc4b1ce37a1ae78e71f7.svg";